export default __webpack_public_path__ + "static/glalie-70a20803db68c1555d7021c83c641525.png";